var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    _vm._l(_vm.processSteps, function (item, index) {
      return _c("Processes-TimeLineItem", {
        key: index,
        attrs: {
          item: item,
          process: _vm.process,
          "is-last": _vm.checkLast(index),
        },
      })
    }),
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }